export default "__VITE_ASSET__O$WEeMqA__"